import { motion } from "framer-motion";

interface Props {
  score: number; // 0-100
}

export function ScoreGauge({ score }: Props) {
  const angle = (score / 100) * 180;
  const color =
    score >= 70 ? "hsl(158, 64%, 52%)" // success green
    : score >= 45 ? "hsl(48, 96%, 53%)" // warning yellow
    : "hsl(0, 72%, 60%)"; // destructive red

  const label = score >= 70 ? "Leve" : score >= 45 ? "Moderado" : "Grave";

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="relative w-48 h-24 overflow-hidden">
        {/* Background arc */}
        <svg viewBox="0 0 200 100" className="w-full h-full">
          <path
            d="M 10 100 A 90 90 0 0 1 190 100"
            fill="none"
            stroke="hsl(var(--muted))"
            strokeWidth="16"
            strokeLinecap="round"
          />
          <motion.path
            d="M 10 100 A 90 90 0 0 1 190 100"
            fill="none"
            stroke={color}
            strokeWidth="16"
            strokeLinecap="round"
            strokeDasharray="283"
            initial={{ strokeDashoffset: 283 }}
            animate={{ strokeDashoffset: 283 - (283 * score) / 100 }}
            transition={{ duration: 1.5, ease: "easeOut" }}
          />
        </svg>
        {/* Needle */}
        <motion.div
          className="absolute bottom-0 left-1/2 origin-bottom"
          style={{ width: 2, height: 70 }}
          initial={{ rotate: -90 }}
          animate={{ rotate: -90 + angle }}
          transition={{ duration: 1.5, ease: "easeOut" }}
        >
          <div className="w-full h-full bg-foreground rounded-full" />
        </motion.div>
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-foreground" />
      </div>
      <div className="text-center">
        <span className="text-3xl font-heading font-bold" style={{ color }}>{score}%</span>
        <p className="text-sm text-muted-foreground font-medium">{label}</p>
      </div>
    </div>
  );
}
